export default "__VITE_ASSET__fNkHSTFY__"